import { render } from "./chatWindow.vue?vue&type=template&id=f1ee8218&scoped=true"
import script from "./chatWindow.vue?vue&type=script&lang=js"
export * from "./chatWindow.vue?vue&type=script&lang=js"

import "./chatWindow.vue?vue&type=style&index=0&id=f1ee8218&lang=scss&scoped=true"

import exportComponent from "D:\\work\\dadao-im\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1ee8218"]])

export default __exports__